module.exports = __webpack_public_path__ + "static/media/icon.78698de6.svg";